




















































































import { Vue, Component } from 'vue-property-decorator';
import OpenSchedulingDialog from '../components/dialogs/OpenSchedulingDialog.vue';
import $api from '../services/api.service';
import { of as observableOf } from 'rxjs';
import {
    catchError,
    pluck
} from 'rxjs/operators';
@Component({
  components: {
    OpenSchedulingDialog
  }
})
export default class EssentialView extends Vue {
  dialog = false;
  disabled = true;
  rules = {
      required: (value: string) => !!value || 'Required.'
  };
  error = '';
  source = 'https://mychart.hawaiipacifichealth.org/mycschedule/SignupAndSchedule/EmbeddedSchedule?id=1001416&vt=3207&dept=15002034&view=plain&useloginsession=1&public=1';

  get code() {
      if (this.$route.query.passcode) {
          const passcode = this.$route.query.passcode as string;
          this.validateCode(passcode);
          return passcode;
      } 
      return '';
  }

  set code(value: string) {
      this.$router.replace({ query: { ...this.$route.query, passcode: value }});
  }

  openDialog() {
    if (!this.disabled) {
      this.dialog = true;
    }
  }

  private validateCode(code: string): void {
      const id = '2xcxs6fjf2tleeo326da';
      if (code && code.length === 13) {
        $api
            .findByTermAsync<{ isValid: boolean; }>(
                `accesscode/${id}/validate`,
                { code: code.trim() }
            )
            .pipe(pluck('isValid'),
                catchError(() => {
                    return observableOf(false);
            }))
            .subscribe(data => {
                this.disabled = !data;
                if (this.disabled) {
                    this.error = 'Invalid Passcode!';
                } else {
                  this.error = '';
                }
            });
      } else {
          this.disabled = true;
          this.error = 'Invalid Passcode!';
      } 
  }
}
